export default function extractUserIdentity(consumerAuthToken) {
  if (!consumerAuthToken) {
    return null;
  }

  const parts = consumerAuthToken
    .split('.')
    .map((string) => Buffer.from(string, 'base64').toString('utf-8'));

  let claims;
  try {
    claims = JSON.parse(parts[1]);
  } catch (e) {
    return null;
  }

  return claims.cust && claims.cust.toString();
}
